import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-migration-banner',
    templateUrl: './view/migrationBanner.component.html',
    styleUrls: ['./css/migrationBanner.component.css']
})

export class MigrationBannerComponent implements OnInit{
    
    ngOnInit(){

    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/migrationBanner/migrationBanner.component.ts